import { render, staticRenderFns } from "./sample-status.vue?vue&type=template&id=3273ddca"
import script from "./sample-status.vue?vue&type=script&lang=js"
export * from "./sample-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports